import apiClient from "../http/apiClient";
import { ACCOUNTS_ENDPOINTS, AUTH_ENDPOINTS } from "../http/endpoints";

const cancelUrl = (id) => `${ACCOUNTS_ENDPOINTS.invites}${id}/cancel/`;

export async function list(params = {}) {
  const response = await apiClient.get(ACCOUNTS_ENDPOINTS.invites, { params });
  return response.data;
}

export async function create(payload) {
  const response = await apiClient.post(AUTH_ENDPOINTS.invites, payload);
  return response.data;
}

export async function cancel(id) {
  const response = await apiClient.post(cancelUrl(id));
  return response.data;
}

export const invitesService = {
  list,
  create,
  cancel,
};

export default invitesService;
